import "../../../src/components/VGrid/_grid.sass";
import Grid from './grid';
export default Grid('layout');
//# sourceMappingURL=VLayout.js.map